async function getData() {
  const url = `https://oms-app.iqrupandritz.com/api/attributes/finishes/ranges/?limit=20`;
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }
    const data = await response.json();
    const cardData = data.results;
    const collectionContainer = document.getElementById("collection_container");
    const collectionHTML = cardData
      .map((finishRange) => {
        const activeFinishes =
          finishRange.finishes?.filter((finish) => finish.active === true) ||
          [];
        if (activeFinishes.length === 0) {
          return "";
        }
        const collectionItemsHTML = activeFinishes
          .map(
            (card) => `
            <div class="card_items">
              <div class="card_image">
                <img src="${card.image}" alt="${card.name}" class="collection_card_img blur-effect" loading="lazy" width="100%" onload="this.classList.remove('blur-effect')">
              </div>
              <div class="card_info">${card.name}</div>
            </div>
          `
          )
          .join("");
        return `
            <div class="collection_block">
              <div class="collection_content">
                <h3 class="collection_header">${finishRange.name} <span>(${activeFinishes.length})</span></h3>
              </div>
              <div class="collection_items">
                ${collectionItemsHTML}
              </div>
            </div>
          `;
      })
      .filter((html) => html !== "")
      .join("");
    collectionContainer.innerHTML = collectionHTML;
  } catch (error) {
    console.error(error.message);
  }
}
document.addEventListener("DOMContentLoaded", function () {
  if (typeof window?.fbq == "function" && window?.fbq) {
    window?.fbq("trackCustom", "Finishes_View", {
      title: "Viewed Finishes Listing Page",
    });
  }
  if (typeof window?.gtag == "function" && window?.gtag) {
    window?.gtag("event", "Finishes_View", {
      title: "Viewed Finishes Listing Page",
    });
  }
  getData();
});